
import { defineComponent, PropType } from "vue";
import { Widget, WidgetType } from "~/models/widget.model";
import WidgetBase from '~/components/widgets/widget.vue';
import AQMap from '~/components/map/aqmap.vue';
import { mapState } from "pinia";
import { useStationStore } from "~/store/station.store";
import { GridStack } from "gridstack";
import { useDashboardStore } from "~/store/dashboard.store";
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { Station } from "~/api/models/station.model";

const DEFAULT_WIDGET_CONFIG: Widget = {
    id: 'Map_1',
    height: 1,
    width: 2,
    minHeight:1,
    minWidth: 3,
    x: 5,
    y: 0,
    type: WidgetType.HISTOGRAM,
}

const fake: Station[] = [
    { name: 'AURA-0121-001', type: 'aura-co2', pairing_token: '', location: { lat: 45.1921885, lon: 5.706943307676825}, metadata: {}},
    { name: 'AURA-0121-002', type: 'aura-co2', pairing_token: '', location: { lat: 45.1518857, lon: 5.726943307676825}, metadata: {}},
    { name: 'AURA-0121-003', type: 'aura-co2', pairing_token: '', location: { lat: 45.1721885, lon: 5.756943307676825}, metadata: {}},
];

export default defineComponent({
    
    extends: WidgetContentBase,

    components: {
        AQMap,
    },

    props: {
        grid: { type: Object as PropType<GridStack | null>},
    },

    computed: {
        ...mapState(useStationStore, ['stations']),
        ...mapState(useDashboardStore, ['currentStation']),

        stationList(): Station[] {
            return this.addable ? fake : this.stations;
        },

        station(): Station {
            return this.addable ? fake[0]: this.currentStation;
        }
    },

    watch: {
        grid(grid): void  {
            this.grid.on('resizestop', () => {
                if(this.$refs.map) {
                    // @ts-ignore
                    this.$refs.map.resize();
                }
            });
        }
    }
})

